import Vue from 'vue'
import { App, Link, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { ZiggyVue } from 'ziggy'
import { Ziggy } from './ziggy'

// Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faFilePdf, faInfo, faPen, faPlus, faTimes, faTrash, faArrowsAltV, faUser, faSignOutAlt, faPaste, faFileImport, faFileUpload, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import BootstrapVue from 'bootstrap-vue'
import money from 'v-money'
import FlashMessage from '~/Layouts/FlashMessage'
import get from 'lodash/get'

Vue.use(BootstrapVue)

Vue.use(ZiggyVue, Ziggy)

require('./bootstrap')
require('~/Filters/Currency')

library.add(faPen, faTrash, faPlus, faCheck, faTimes, faFilePdf, faInfo, faArrowsAltV, faUser, faSignOutAlt, faPaste, faFileImport, faUpload, faFileUpload)

InertiaProgress.init()

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('flash-message', FlashMessage)
Vue.component('Link', Link)

Vue.use(money, {
  decimal: ',',
  thousands: ' ',
  prefix: '',
  precision: 0,
  masked: true
})

Vue.use(plugin)

const el = document.getElementById('app')

const vm = new Vue({
  render: h => h(App, {
    props: {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: name => require(`./Pages/${name}`).default
    }
  })
}).$mount(el)

Vue.mixin({
  methods: {
    fieldState: field => get(vm.$page.props.errors, field) ? false : null,
    fieldError: field => get(vm.$page.props.errors, field) ? vm.$page.props.errors[field][0] : ''
  }
})
